import React from "react";
import PropTypes from "prop-types";

import styles from "./Typography.module.css";

function Typography({ className, component, family = "", children, ...other }) {
  let variant = family === "" ? {} : { fontFamily: family };

  if (component === "h1") {
    return (
      <h1
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h1>
    );
  }

  if (component === "h2") {
    return (
      <h2
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h2>
    );
  }

  if (component === "h3") {
    return (
      <h3
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h3>
    );
  }

  if (component === "h4") {
    return (
      <h4
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h4>
    );
  }

  if (component === "h5") {
    return (
      <h5
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h5>
    );
  }

  if (component === "h6") {
    return (
      <h6
        className={styles.typography + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h6>
    );
  }

  if (component === "title1") {
    return (
      <h2
        className={styles.title1 + " " + className}
        style={variant}
        {...other}
      >
        {children}
      </h2>
    );
  }

  if (component === "body1") {
    return (
      <h4 className={styles.body1 + " " + className} style={variant} {...other}>
        {children}
      </h4>
    );
  }

  if (component === "span") {
    return (
      <h4 className={styles.span + " " + className} style={variant} {...other}>
        {children}
      </h4>
    );
  }
}

Typography.propTypes = {
  component: PropTypes.oneOf([
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "title1",
    "body1",
  ]),
  family: PropTypes.string,
  className: PropTypes.string,
};

export default Typography;
